import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { AccountService } from '../../services/account.service';
import { IAddExistingCardForm } from '../add-existing-card-form/add-existing-card-form.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ValidatorsService } from 'src/app/shared/services/validators.service';
import { timeout } from 'rxjs/operators';

@Component({
    selector: 'app-card-number-modal',
    templateUrl: './card-number-modal.component.html',
    styleUrls: ['./card-number-modal.component.scss'],
    standalone: false
})
export class CardNumberModalComponent implements OnInit {
  form: FormGroup;
  formErrors: Map<string, string> = new Map<string, string>();

  patternReference: any = {};

  // change for with the card number to output it properly
  @Output() onSubmit: EventEmitter<string> = new EventEmitter<string>();

  ResponseFalse: boolean = false;
  responseError: string = "incorrect card number or the card is already used!";

  constructor(
    private account: AccountService,
    private fb: FormBuilder,
    private loader: LoaderService,
    private modalCtrl: ModalController,
    //private translate: TranslateService,
    public validators: ValidatorsService
  ) { }

  ngOnInit() {

    /*
    this.form = this.fb.group({
      'memberCard': ['', this.validators.formBuilderValidationInitializer(true, null, null)]
    });
    */
    this.form = this.fb.group({
      memberCard: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null),
        updateOn: 'change'
      })
    });

    /*
    this.form["patternReference"] = {
      memberCard: null
    };
    */
    this.patternReference = {
      memberCard: null
    };

    //this.validators.trackInputChange(this.form);
    this.validators.trackInputChange(this.form, this.patternReference);
  }

  
  async onFormSubmitted() {

      //sanitizing
      this.form.setValue(this.validators.multiSanitizerInput(this.form.value));

      if (!this.form.valid)
        return;

      this.formErrors.clear();

      const loader = await this.loader.create();
      await loader.present();

      this.account.confirmMemberCard(this.form.get("memberCard").value)
        .subscribe(async (result: boolean) => {

            loader.dismiss();

            if(result) {
              this.onSubmit.emit(this.form.get("memberCard").value);

              this.modalCtrl.dismiss(this.form.get("memberCard").value);
            } else {
              this.ResponseFalse = true;
              setTimeout(() => {
                this.ResponseFalse = false;
              }, 3500); 
            }
        });
    } 
  
    cancel() {
      this.modalCtrl.dismiss(null);
    }
    
}
